module.exports = __webpack_public_path__ + "static/img/preview-07.d71ea49b.webp";